import React from 'react'

export const Comments = ({ commentBox }) => {
  return <div ref={commentBox} />
}
